export var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["Pending"] = "pending";
    VerificationStatus["Invalid"] = "invalid";
    VerificationStatus["Valid"] = "valid";
    VerificationStatus["Rejected"] = "rejected";
})(VerificationStatus || (VerificationStatus = {}));
//# sourceMappingURL=VerificationStatus.js.map